var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 38,
    rx: 8,
    fill: "#101828"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4996 22.8333C17.2263 22.8333 16.9996 22.6067 16.9996 22.3333V19.54L16.5196 20.02C16.3263 20.2133 16.0063 20.2133 15.813 20.02C15.6196 19.8267 15.6196 19.5067 15.813 19.3133L17.1463 17.98C17.2863 17.84 17.5063 17.7933 17.693 17.8733C17.8796 17.9467 17.9996 18.1333 17.9996 18.3333V22.3333C17.9996 22.6067 17.773 22.8333 17.4996 22.8333Z",
    fill: "#F9FAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8336 20.1667C18.707 20.1667 18.5803 20.12 18.4803 20.02L17.147 18.6867C16.9536 18.4933 16.9536 18.1733 17.147 17.98C17.3403 17.7867 17.6603 17.7867 17.8536 17.98L19.187 19.3133C19.3803 19.5067 19.3803 19.8267 19.187 20.02C19.087 20.12 18.9603 20.1667 18.8336 20.1667Z",
    fill: "#F2F4F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5007 26.1667H17.5007C13.8807 26.1667 12.334 24.62 12.334 21V17C12.334 13.38 13.8807 11.8333 17.5007 11.8333H20.834C21.1073 11.8333 21.334 12.06 21.334 12.3333C21.334 12.6067 21.1073 12.8333 20.834 12.8333H17.5007C14.4273 12.8333 13.334 13.9267 13.334 17V21C13.334 24.0733 14.4273 25.1667 17.5007 25.1667H21.5007C24.574 25.1667 25.6673 24.0733 25.6673 21V17.6667C25.6673 17.3933 25.894 17.1667 26.1673 17.1667C26.4407 17.1667 26.6673 17.3933 26.6673 17.6667V21C26.6673 24.62 25.1207 26.1667 21.5007 26.1667Z",
    fill: "#F2F4F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1673 18.1667H23.5007C21.2207 18.1667 20.334 17.28 20.334 15V12.3333C20.334 12.1333 20.454 11.9467 20.6407 11.8733C20.8273 11.7933 21.0407 11.84 21.1873 11.98L26.5207 17.3133C26.6607 17.4533 26.7073 17.6733 26.6273 17.86C26.5473 18.0467 26.3673 18.1667 26.1673 18.1667ZM21.334 13.54V15C21.334 16.72 21.7807 17.1667 23.5007 17.1667H24.9607L21.334 13.54Z",
    fill: "#F2F4F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.2c64b29a83e96dbefa81d3d5427b0ec1.svg";
export { ForwardRef as ReactComponent };